import type { Flags, FlagProps } from 'react-phone-number-input';
import flagsMap from 'react-phone-number-input/flags';

export const FlagComponent = ({ country, countryName }: FlagProps): React.ReactElement => {
  const flags: Flags = flagsMap;
  const Flag = flags[country];
  return (
    <span className="flex h-4 w-6 overflow-hidden rounded-sm bg-foreground/20 [&_svg:not([class*='size-'])]:size-full">
      {Flag && <Flag title={countryName} />}
    </span>
  );
};
